import { Injectable } from '@angular/core';
import { RequestService } from 'src/app/core/service/request.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class BalanceService {

  constructor(
    private requestService: RequestService
  ) { }

  GetDefaultValue(CompanyID:string,UserID:string){
    var param = {
      "CompanyID": CompanyID,
      "UserID": UserID
    };
    return this.requestService.Post<any>(environment.baseUrl + '/PointGain/GetDefaultValue',param);
  }

  GetDetails(CompanyID:string,UserID:string){
    var param = {
      "CompanyID": CompanyID,
      "UserID": UserID
    };
    return this.requestService.Post<any>(environment.baseUrl + '/PointGain/GetDetails',param);
  }
}
